import { applyMiddleware, compose, createStore } from 'redux';
import { createBrowserHistory } from 'history';
import { routerMiddleware as createRouterMiddleware } from 'connected-react-router';
import createSagaMiddleware from 'redux-saga';

import createRootReducer from '../reducers';
import rootSaga from '../sagas';

export const history = createBrowserHistory();
const configureStore = state => {
  const sagaMiddleware = createSagaMiddleware();
  const routerMiddleware = createRouterMiddleware(history);

  const middleware = [sagaMiddleware, routerMiddleware];
  let composeEnhancer;
  if (
    process.env.REACT_APP_ENV === 'development' ||
    process.env.NODE_ENV === 'development'
  ) {
    const { createLogger } = require('redux-logger');
    // https://github.com/LogRocket/redux-logger#duration-boolean
    // duration: Print duration of each action. Which use full in dev and local
    middleware.push(createLogger({ collapsed: true, duration: true }));
    composeEnhancer = window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ || compose;
  }
  const store = createStore(
    createRootReducer(history),
    state,
    process.env.REACT_APP_ENV === 'development'
      ? composeEnhancer(applyMiddleware(...middleware))
      : applyMiddleware(...middleware)
  );
  store.sagaTask = sagaMiddleware.run(rootSaga);

  // dynamically add reducer main function
  store.asyncReducers = {};
  store.injectReducer = (key, reducer) => {
    store.asyncReducers[key] = reducer;
    store.replaceReducer(createRootReducer(history, store.asyncReducers));
    return store;
  };

  return store;
};
export default configureStore;
